import React, { useState } from "react";
import {
  Card,
  CardBody,
  Input,
  Button,
  Row,
  Col,
} from "reactstrap";
import { PayrollClient } from "services";
import { Trans } from "react-i18next";
import { MonthlyTable } from "./MonthlyTable";
import { useQuery } from "react-query";
import { Control } from "react-redux-form";
import Select from "react-select";
import { FormGroup } from "components/common";
import { useForm } from "hooks";

const INITIAL_STATE = {
  employee_name: '',
  start_date: '',
  end_date: '',
}

const ListMonthly = ({ t, selectedOrganisation, xero, match}) => {
  const { Form } = useForm();
  const payrollClient = PayrollClient();

  const [refetchTrigger, setRefetchTrigger] = useState(false)
  const [selected_rows, setSelectedRows] = useState([])
  const [searchForm, setSearchForm] = useState(INITIAL_STATE)

  const { data: employees, isLoading } = useQuery('employees', () =>
    payrollClient.get("employees?status=Active&include_all=false")
      .get("data")
  )

  const _fetchMonthlyEmployeesAttendance = async (pageIndex, pageSize) => {
    try {
      var attendance = await payrollClient.get('monthly_attendance_report', { params: { ...{ 'ordering': `employee`, 'offset': pageIndex, 'limit': pageSize }, ...searchForm } }).get('data')
      return { ...attendance, items: attendance.results }
    }
    catch (err) {
      console.error(err)
      return "Error at loading attendance report"
    }
  }

  const resetSearchFields = () => {
    setSearchForm(INITIAL_STATE)
    setRefetchTrigger((old) => !old)
  }

  return (
    <div className="settingsmanagement">
      <Row>
        <Col xs="11" md="12" sm="12">
          <Card>
            <CardBody>
              <h4 className="mt-2 mb-4"><Trans>Attendance Report Monthly</Trans></h4>
              <Row className="mb-3">
                <Col className="col-xs-12 col-md-12 pr-0">
                  <Form className="form" style={{ display: "flex" }}>
                    <Col className="col-md-3 col-xs-6 mb-3">
                      <FormGroup className="pb-3" label="Employee" model=".employee" addControlClass={false}>
                        <Control.text
                          model=".employee"
                          component={Select}
                          options={employees}
                          onChange={(value) => setSearchForm({ ...searchForm, employee_id: value })}
                          simpleValue
                          clearable={false}
                          valueKey="id"
                          labelKey="full_name"
                          multi
                        />
                      </FormGroup>
                    </Col>
                    <FormGroup className="ml-2">
                      <label><Trans>Start Date</Trans></label>
                      <Input
                        type="month"
                        className="col-xs-12 col-md-12 pl-3"
                        style={{
                          fontFamily: "FontAwesome, Arial",
                          fontStyle: "normal",
                        }}
                        value={searchForm.start_date}
                        onChange={(e) => setSearchForm({ ...searchForm, start_date: e.target.value })}
                      />
                    </FormGroup>
                    <FormGroup className="ml-2">
                      <label><Trans>End Date</Trans></label>
                      <Input
                        type="month"
                        className="col-xs-12 col-md-12 pl-3"
                        style={{
                          fontFamily: "FontAwesome, Arial",
                          fontStyle: "normal",
                        }}
                        value={searchForm.end_date}
                        onChange={(e) => setSearchForm({ ...searchForm, end_date: e.target.value })}
                      />
                    </FormGroup>
                    <div className="ml-2" style={{
                      marginTop: "28px"
                    }}>
                      <Button color="success" className="mr-2" onClick={() => setRefetchTrigger((old) => !old)}><Trans>Search</Trans></Button>
                      <Button className="mr-2" onClick={resetSearchFields}><Trans>Reset</Trans></Button>
                    </div>
                  </Form>
                </Col>
              </Row>
              <Row>
                <Col>
                  <MonthlyTable t={t} fetch={_fetchMonthlyEmployeesAttendance} reload={false} setSelectedRows={setSelectedRows} refetch={refetchTrigger} setRefetchTrigger={setRefetchTrigger} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ListMonthly;
